/** 培训模块 AI 助手开关，第二期上线时改为 true */
export const TRAINING_AI_ASSISTANT_ENABLED = false



// WEBPACK FOOTER //
// ./src/views/training/training.constants.js